export default __webpack_public_path__ + "static/media/m_faq.7ca6c18a.png";